"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHAT_ATTACHMENT_REGEX = void 0;
var _react = _interopRequireDefault(require("react"));
var _ = require("..");
var _reactSpinners = require("react-spinners");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* babel-plugin-inline-import './images/image-decorator-file.svg' */
var documentIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAyOCAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuNzUgMzZDMS45ODMzMyAzNiAxLjMzMzMzIDM1LjczMzMgMC44IDM1LjJDMC4yNjY2NjcgMzQuNjY2NyAwIDM0LjAxNjcgMCAzMy4yNVYyLjc1QzAgMS45ODMzMyAwLjI2NjY2NyAxLjMzMzMzIDAuOCAwLjhDMS4zMzMzMyAwLjI2NjY2NyAxLjk4MzMzIDAgMi43NSAwSDE5LjQ1TDI4IDguNTVWMzMuMjVDMjggMzQuMDE2NyAyNy43MzMzIDM0LjY2NjcgMjcuMiAzNS4yQzI2LjY2NjcgMzUuNzMzMyAyNi4wMTY3IDM2IDI1LjI1IDM2SDIuNzVaTTIuNzUgMzQuNDVIMjUuMjVDMjUuNTUgMzQuNDUgMjUuODI1IDM0LjMyNSAyNi4wNzUgMzQuMDc1QzI2LjMyNSAzMy44MjUgMjYuNDUgMzMuNTUgMjYuNDUgMzMuMjVWOS4ySDE4LjdWMS41NUgyLjc1QzIuNDUgMS41NSAyLjE3NSAxLjY3NSAxLjkyNSAxLjkyNUMxLjY3NSAyLjE3NSAxLjU1IDIuNDUgMS41NSAyLjc1VjMzLjI1QzEuNTUgMzMuNTUgMS42NzUgMzMuODI1IDEuOTI1IDM0LjA3NUMyLjE3NSAzNC4zMjUgMi40NSAzNC40NSAyLjc1IDM0LjQ1Wk0xLjU1IDMzLjI1VjEuNTVDMS41NSAxLjU1IDEuNTUgMS42NzUgMS41NSAxLjkyNUMxLjU1IDIuMTc1IDEuNTUgMi40NSAxLjU1IDIuNzVWMzMuMjVaIiBmaWxsPSIjMzUzNTM1Ii8+Cjwvc3ZnPgo=";
/* babel-plugin-inline-import './images/image-decorator-cancel.svg' */
var cancelIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNCAxNUwxMCAxMS40TDEzLjYgMTVMMTUgMTMuNkwxMS40IDEwTDE1IDYuNEwxMy42IDVMMTAgOC42TDYuNCA1TDUgNi40TDguNiAxMEw1IDEzLjZMNi40IDE1Wk0xMCAyMEM4LjYxNjY3IDIwIDcuMzE2NjcgMTkuNzM3MyA2LjEgMTkuMjEyQzQuODgzMzMgMTguNjg3MyAzLjgyNSAxNy45NzUgMi45MjUgMTcuMDc1QzIuMDI1IDE2LjE3NSAxLjMxMjY3IDE1LjExNjcgMC43ODggMTMuOUMwLjI2MjY2NyAxMi42ODMzIDAgMTEuMzgzMyAwIDEwQzAgOC42MTY2NyAwLjI2MjY2NyA3LjMxNjY3IDAuNzg4IDYuMUMxLjMxMjY3IDQuODgzMzMgMi4wMjUgMy44MjUgMi45MjUgMi45MjVDMy44MjUgMi4wMjUgNC44ODMzMyAxLjMxMjMzIDYuMSAwLjc4N0M3LjMxNjY3IDAuMjYyMzMzIDguNjE2NjcgMCAxMCAwQzExLjM4MzMgMCAxMi42ODMzIDAuMjYyMzMzIDEzLjkgMC43ODdDMTUuMTE2NyAxLjMxMjMzIDE2LjE3NSAyLjAyNSAxNy4wNzUgMi45MjVDMTcuOTc1IDMuODI1IDE4LjY4NzMgNC44ODMzMyAxOS4yMTIgNi4xQzE5LjczNzMgNy4zMTY2NyAyMCA4LjYxNjY3IDIwIDEwQzIwIDExLjM4MzMgMTkuNzM3MyAxMi42ODMzIDE5LjIxMiAxMy45QzE4LjY4NzMgMTUuMTE2NyAxNy45NzUgMTYuMTc1IDE3LjA3NSAxNy4wNzVDMTYuMTc1IDE3Ljk3NSAxNS4xMTY3IDE4LjY4NzMgMTMuOSAxOS4yMTJDMTIuNjgzMyAxOS43MzczIDExLjM4MzMgMjAgMTAgMjBaIiBmaWxsPSIjMUQ2NUExIi8+Cjwvc3ZnPgo=";
var EditorImage = function EditorImage(_ref) {
  var decoratedText = _ref.decoratedText,
    onDeleteFile = _ref.onDeleteFile,
    editorState = _ref.editorState;
  var files2 = decoratedText.match(/(?<=\[).+?(?=\])/g).map(function (m) {
    var _m$split = m.split('~'),
      _m$split2 = _slicedToArray(_m$split, 4),
      name = _m$split2[0],
      type = _m$split2[1],
      loadingState = _m$split2[2],
      objectUrl = _m$split2[3];
    return {
      name: name,
      type: type,
      loadingState: loadingState,
      objectUrl: objectUrl === 'null' ? null : objectUrl
    };
  });
  var onKeyDownDeleteButton = function onKeyDownDeleteButton(evt, i, fileName, editorState) {
    evt.preventDefault();
    evt.stopPropagation();
    if (evt.keyCode === 32) {
      onDeleteFile(i, fileName, editorState);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, files2.map(function (f, i) {
    var _f$objectUrl;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "sa-wysiwyg-image"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: (_f$objectUrl = f.objectUrl) !== null && _f$objectUrl !== void 0 ? _f$objectUrl : documentIcon,
      alt: ""
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "sa-wysiwyg-image-meta"
    }, /*#__PURE__*/_react.default.createElement("p", null, f.name), /*#__PURE__*/_react.default.createElement("p", null, f.type)), /*#__PURE__*/_react.default.createElement("div", {
      className: "sa-wysiwyg-image-button"
    }, f.loadingState === "loading" ? /*#__PURE__*/_react.default.createElement(_reactSpinners.ClipLoader, {
      size: 16
    }) : f.loadingState === "waiting" ? /*#__PURE__*/_react.default.createElement(_.Button, {
      onClick: function onClick() {
        onDeleteFile(i, f.name, editorState);
      },
      onKeyDown: function onKeyDown(evt) {
        onKeyDownDeleteButton(evt, i, f.name, editorState);
      }
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: cancelIcon,
      alt: ""
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)));
  }));
};
var CHAT_ATTACHMENT_REGEX = /@SA_IMAGE\[([[\w.\-_#@!£$%|^"':;+={}?\(\)\[\] ]+~[\w\\\/]+~\w+(.*)+\])+/gm;
exports.CHAT_ATTACHMENT_REGEX = CHAT_ATTACHMENT_REGEX;
function strategy(contentBlock, callback, contentState) {
  findWithRegex(CHAT_ATTACHMENT_REGEX, contentBlock, callback);
}
function findWithRegex(regex, contentBlock, callback) {
  var text = contentBlock.getText();
  var matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}
function createDecorator(saProps) {
  var component = function component(editorProps) {
    return /*#__PURE__*/_react.default.createElement(EditorImage, _extends({}, saProps, editorProps));
  };
  return {
    strategy: strategy,
    component: component
  };
}
var _default = createDecorator;
exports.default = _default;